import React from "react";
import "../css/DashboardFooter.css";

const DashboardFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="dashboard-footer text-center py-3">
      <p className="mb-0">
        © {currentYear} <span className="brand">Auxilium</span>. All rights reserved.
        
        <br/>
        Developed by SkyBros IT Solutions, TPT.
      </p>
    </footer>
  );
};

export default DashboardFooter;
